var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.029,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1C6.372 1 1 6.373 1 13s5.372 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M13.005 9.41a3.585 3.585 0 0 0-3.59 3.591 3.585 3.585 0 0 0 3.59 3.591 3.585 3.585 0 0 0 3.59-3.59 3.585 3.585 0 0 0-3.59-3.592m0 5.926A2.34 2.34 0 0 1 10.671 13a2.337 2.337 0 0 1 2.334-2.335 2.337 2.337 0 0 1 2.334 2.335 2.34 2.34 0 0 1-2.334 2.335m4.575-6.073a.836.836 0 0 1-.837.838.838.838 0 1 1 .837-.838m2.378.85c-.053-1.122-.31-2.116-1.131-2.934-.819-.82-1.813-1.075-2.935-1.132-1.156-.065-4.621-.065-5.778 0-1.118.053-2.112.31-2.934 1.129-.822.818-1.075 1.812-1.131 2.934-.066 1.157-.066 4.623 0 5.779.053 1.122.31 2.116 1.131 2.935.822.818 1.812 1.075 2.934 1.13 1.157.066 4.622.066 5.778 0 1.122-.052 2.116-.309 2.935-1.13.819-.82 1.075-1.813 1.131-2.935.066-1.156.066-4.62 0-5.776m-1.494 7.017a2.36 2.36 0 0 1-1.33 1.33c-.923.367-3.11.282-4.129.282s-3.21.081-4.128-.281a2.36 2.36 0 0 1-1.331-1.331c-.366-.922-.282-3.11-.282-4.129s-.08-3.21.282-4.128a2.36 2.36 0 0 1 1.33-1.332c.923-.365 3.11-.281 4.129-.281s3.21-.081 4.128.281a2.36 2.36 0 0 1 1.331 1.332c.366.922.282 3.11.282 4.128s.084 3.21-.282 4.129"
  })));
};
export default SvgInstagram;